import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MeasurementSystem } from '../types/measurement-system.type';

@Injectable({ providedIn: 'root' })
export class DpMeasurementSystemsApiService {
  readonly #httpClient = inject(HttpClient);
  readonly #occEndpoints = inject(OccEndpointsService);

  getMeasurementSystems(): Observable<MeasurementSystem[]> {
    return this.#httpClient
      .get<{ measurementSystems: MeasurementSystem[] }>(this.#occEndpoints.buildUrl('measurementSystem'))
      .pipe(map((data) => data.measurementSystems ?? []));
  }

  setActiveMeasurementSystem(measurementSystem: string): Observable<unknown> {
    return this.#httpClient.post(this.#occEndpoints.buildUrl('preferences'), { measurementSystem });
  }
}
